module.exports = __webpack_public_path__ + "img/mic-brokerage-md.9619ff13.png";